import React, { ComponentProps, forwardRef } from 'react';
import { DialogContent as DialogContentMUI } from '@mui/material';

type Props = ComponentProps<typeof DialogContentMUI> & {
  margin?: 'none' | 'auto';
};

const DialogContent = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { margin, sx, ...rest } = props;

  return (
    <DialogContentMUI
      ref={ref}
      {...rest}
      sx={{
        ...(margin === 'none' && {
          padding: '0 !important',
        }),
        ...sx,
      }}
    />
  );
});

DialogContent.displayName = 'DialogContent';

export default DialogContent;
